import { ColorDynamic } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import styled from 'styled-components';

export const GradientBackground = styled(Box)`
  background: linear-gradient(
    89.58deg,
    ${ColorDynamic.Red50} 0%,
    ${ColorDynamic.Purple50} 50%,
    ${ColorDynamic.Teal50} 100%
  );
  color: ${ColorDynamic.Dark500};
`;
